import { FeatureToggle, isFeatureEnabled } from '../../../util/featureToggle';
import GTM from '../../../gtm/GTM';
import GTMDetailBackButtonClickModel from '../../../gtm/models/GTMDetailBackButtonClickModel';
import GoogleAnalyticsEvent from '../../../common/GoogleAnalyticsEvents';
import HouseDetailTrackingEvent from '../HouseDetailTracking';

export default class DetailBackButtonManager {
    static #instance: DetailBackButtonManager | null = null;

    public static getInstance(): DetailBackButtonManager {
        if (this.#instance === null) {
            this.#instance = new DetailBackButtonManager();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    #backButtons: HTMLAnchorElement[] = [];

    set backButtons(backButtons: HTMLAnchorElement[]) {
        this.#removeEventListeners();
        this.#backButtons = backButtons;
        this.#setEventListeners();
    }

    private constructor() {
        this.backButtons = Array.from(
            document.querySelectorAll<HTMLAnchorElement>('[data-role="detail-back-button"]')
        );
    }

    #removeEventListeners(): void {
        for (const backButton of this.#backButtons) {
            backButton.removeEventListener('click', this.#handleClick);
        }
    }

    #setEventListeners(): void {
        for (const backButton of this.#backButtons) {
            backButton.addEventListener('click', this.#handleClick);
        }
    }

    readonly #handleClick = (event: Event): void => {
        if (isFeatureEnabled(FeatureToggle.GOOGLE_TAG_MANAGER)) {
            GTM.track(GTMDetailBackButtonClickModel.parseToGTMData());
        } else {
            GoogleAnalyticsEvent.trackEvent(HouseDetailTrackingEvent.BACK_BUTTON_CLICK);
        }

        if (window.history.length <= 1) {
            return;
        }
        event.preventDefault();

        window.history.back();
    };
}
